import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {KTSVG} from '../../../../_metronic/helpers'
import {GeneralDataOFLoginUser} from '../../../Utils/Auth'

const CustomCreditPurchasePopup = ({show, handleClose, setCustomCredit, pay}: any) => {
  const [quickSms, setQuickSms] = useState('sms')
  const [qty, setQty] = useState(0)
  const [price, setPrice] = useState(0)
  const [error, setError] = useState('')
  const userData = GeneralDataOFLoginUser()

  const PriceRateListSMS = useSelector((state: any) => state?.priceRules?.RateCardList)?.filter(
    (key: any) => key?.type == 'SMS'
  )
  const PriceRateListMMS = useSelector((state: any) => state?.priceRules?.RateCardList)?.filter(
    (key: any) => key?.type == 'MMS'
  )
  const ProductListmms = useSelector((state: any) => state?.productList?.productList)?.filter(
    (key: any) => key?.metadata?.type == 'mms'
  )
  const ProductListsms = useSelector((state: any) => state?.productList?.productList)?.filter(
    (key: any) => key?.metadata?.type == 'sms'
  )

  const handleCheckout = () => {
    pay()
    handleClose()
  }

  useEffect(() => {
    if (quickSms == 'sms') {
      let price =
        PriceRateListSMS?.find(
          (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
        ) == undefined
          ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
            PriceRateListSMS?.find(
              (key: any) =>
                key?.creditendrange ===
                Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : PriceRateListSMS?.find(
              (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
            )?.finalPrice
      setPrice(price)
      setCustomCredit({
        priceperItems: price,
        type: quickSms,
        credits: qty,
      })
    } else {
      let price =
        PriceRateListMMS?.find(
          (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
        ) == undefined
          ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
            PriceRateListMMS?.find(
              (key: any) =>
                key?.creditendrange ===
                Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : PriceRateListMMS?.find(
              (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
            )?.finalPrice
      setPrice(price)
      setCustomCredit({
        priceperItems: price,
        type: quickSms,
        credits: qty,
      })
    }
  }, [quickSms, qty])

  const handleChange = (e: any) => {
    if (e.target.value == 'sms' || quickSms == 'sms') {
      setQuickSms('sms')
      let price =
        PriceRateListSMS?.find(
          (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
        ) == undefined
          ? // ? PriceRateListSMS?.[PriceRateListSMS?.length - 1]?.finalPrice
            PriceRateListSMS?.find(
              (key: any) =>
                key?.creditendrange ===
                Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : PriceRateListSMS?.find(
              (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
            )?.finalPrice
      setPrice(price)
      setCustomCredit({
        priceperItems: price,
        type: quickSms,
        credits: qty,
      })
    } else {
      setQuickSms('mms')
      let price =
        PriceRateListMMS?.find(
          (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
        ) == undefined
          ? // ? PriceRateListMMS?.[PriceRateListMMS?.length - 1]?.finalPrice
            PriceRateListMMS?.find(
              (key: any) =>
                key?.creditendrange ===
                Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
            )?.finalPrice
          : PriceRateListMMS?.find(
              (key: any) => key?.creditendrange >= +qty && key?.creditstartrange <= +qty
            )?.finalPrice
      setPrice(price)
      setCustomCredit({
        priceperItems: price,
        type: quickSms,
        credits: qty,
      })
    }
  }

  const handleInput = (e: any) => {
    setQty(e?.target?.value)

    if (e?.target?.value > 4000000) {
      setError('Maximum credit must be less than 4000000')
    } else if (e?.target?.value < 20) {
      setError('Minimum credit must be greater than 20')
    } else {
      setError('')
    }
  }

  const ClosePopup = () => {
    handleClose()
    setQty(0)
    setPrice(0)
  }

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Add credits</h2>
          <div className='btn btn-icon btn-sm' onClick={ClosePopup}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-20 pb-15'>
          <div className='row mb-2'>
            <div className='col-7 border-end pe-15'>
              <div className='d-flex gap-4'>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='sms'
                    checked={quickSms == 'sms'}
                    id='quick_sms_radio2'
                    onClick={() => {
                      setQuickSms('sms')
                    }}
                  />
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>
                </div>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='mms'
                    checked={quickSms == 'mms'}
                    id='quick_mms_radio2'
                    onClick={() => {
                      setQuickSms('mms')
                    }}
                  />
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                </div>
              </div>
              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>
                  How many credits you want to BUY?
                </label>
                <input
                  maxLength={6}
                  name='number'
                  onChange={handleInput}
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />

                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'>{error}</div>
                </div>
              </div>
            </div>
            <div className='col-5 ps-10'>
              <h4 className='mb-4'>Total cost</h4>
              <h1 className='text-info fs-3qx fw-boldest'>
                ${(+qty * price + (+qty * price * 10) / 100).toFixed(2)}
              </h1>
              <div className='fs-6 text-gray-500'>or {price}/message</div>
            </div>
            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={() => {
                    handleClose()
                    setPrice(0)
                    setQty(0)
                  }}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>
              <button
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded  w-100px p-3 border border-primary'
                disabled={error !== ''}
                onClick={handleCheckout}
              >
                <span className='indicator-label'>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CustomCreditPurchasePopup
